import { useContext, useEffect } from 'react'
import { DocumentationContext } from '../../context'
import DocumentationComments from './DocComments'
import AddContent from '../../assets/img/add-content.svg'
import { Typography } from '@mui/material'
import { ResourceType } from '../../types'

interface DocForumCommentsProps {
    resource?: ResourceType
}

export default function DocForumComments({ resource }: DocForumCommentsProps) {
    const context = useContext(DocumentationContext)
    const documentationContext = useContext(DocumentationContext)

    useEffect(() => {
        if(context?.referencedDoc?.fullScreen){
            return
        }
        if (resource && (!resource.linkedComments || resource.linkedComments !== context?.referencedDoc?.reference)) {
            documentationContext?.setReferencedDoc({
                title: resource.name,
                reference: resource?.linkedComments || '',
                forum: {
                    active: true,
                    selected: 1,
                    target: resource
                }
            })
        }
    }, [resource, context?.referencedDoc?.fullScreen])

    return (
        <div className='referenced-doc'>
            {!context?.page?.comments || context?.page?.comments.length === 0 ? <div className='referenced-doc-content d-flex'>
                <img src={AddContent} alt="Agrega Contenido!" />
                <Typography variant='h3' className='m-auto'>¿Dudas o consultas?<br /> Agrega un comentario para que podamos apoyarte</Typography>
            </div> : <div style={{ marginTop: '0.5rem', textAlign: 'right' }}>
                <Typography variant='caption'>{context?.page?.comments.length} comentario(s)</Typography>
            </div>}
            <DocumentationComments />
        </div>
    )
}
